import { i18n } from "@/plugins/i18n";
import formatHelper from '@nextories/vue-core-components/src/utils/helpers/format';

export default {
  mappingMeetingOperator(operator: string, users: [{
    address_state: string,
    first_name: string,
    last_name: string,
  }]) {
    const user = Object.values(users).find(
      (user) => operator === user.address_state,
    );
    if (user) {
      return user;
    }
    return undefined;
  },
  formatMeeting(meeting: {
    start: string,
    end: string,
  }, operator: string, users: [{
    address_state: string,
    first_name: string,
    last_name: string,
  }], hasParams: boolean) {
    const getOperator = this.mappingMeetingOperator(operator, users);
    return {
      ...hasParams ? {
        params: meeting
      } : {
        ...meeting
      },
      params: hasParams ? {
        ...meeting,
      } : meeting,
      operator: getOperator,
      content: {
        operator: getOperator
          && i18n.global.t("meeting.operator", {
            firstName: getOperator.first_name,
            lastName: getOperator.last_name,
          }),
        date: i18n.global.t("meeting.infoDate", {
          date: formatHelper.formatDate(new Date(meeting.start)),
          start: formatHelper.formatHours(meeting.start),
          end: formatHelper.formatHours(meeting.end),
        }),
      },
    }
  },
}
